import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { supabase } from "@/integrations/supabase/client";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

async function notifySlack(email: string, source: string) {
  try {
    await supabase.functions.invoke('slack-waitlist-notify', {
      body: { email, source },
    });
  } catch (err) {
    console.error('Slack notification failed (non-blocking):', err);
  }
}

export async function requestAccessCsv(email: string, source: string = 'Homepage') {
  // Identify user in Zipy for session tracking
  if ((window as any).zipy) {
    (window as any).zipy.identify(email, { email, source });
  }

  // Persist to waitlist table
  const { error } = await supabase.from('waitlist').insert({ email, source });
  if (error) {
    console.error('[Waitlist] DB insert failed:', error.message);
  }

  // Send Slack notification as secondary channel
  await notifySlack(email, source);
  return new Response(JSON.stringify({ success: true }), { status: 200 });
}
